export default __webpack_public_path__ + "static/authenticate-icon-seller-verification-alt-light-blue-26cb920dbf8a8cd3bf8229593c67ac98.svg";